export default __webpack_public_path__ + "images/classification_upload_unclassified-Tp1W1.png";